import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { searchPath } from "@outschool/routes";
import { TrackedButton } from "@outschool/ui-components-shared";
import {
  MobileActivityListComponent,
  useParentsAlsoLikeList
} from "@outschool/ui-components-website";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

export const ParentsAlsoLikeList = ({
  activity
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
}) => {
  const bestFitTopic = activity?.attributes
    .find(
      attr =>
        attr.key === "best_fit_topic" && attr.value !== "NO_TOPICS_APPLIED"
    )
    ?.value?.split(" > ")
    .pop();

  const searchFilters = {
    q: bestFitTopic || activity.title
  };
  const pageLocation = "ClassDetail_CSR_Mobile";

  const searchListings = useParentsAlsoLikeList({
    searchFilters,
    limit: 16,
    pageLocation
  });

  const Link = useLinkComponent();

  const { t } = useTranslation(
    "client\\components\\detailPage\\mobileBelowClassDetail"
  );
  return (
    <>
      {!!searchListings?.length && (
        <>
          <MobileActivityListComponent
            lists={searchListings}
            pageLocation={pageLocation}
            title={t("Parents also liked")}
          />
          <TrackedButton
            variant="outlined"
            sx={{ width: "min-content", display: "flex", margin: "4rem auto" }}
            component={Link}
            to={searchPath({ ...searchFilters, offset: 16 })}
            trackingName="mobile_below_class_detail_see_more_classes"
            trackingSharedProperties={{
              activity_uid: activity.uid,
              cards_loaded: 16
            }}
          >
            {t("See More Classes")}
          </TrackedButton>
        </>
      )}
    </>
  );
};
